import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import pick from 'lodash/pick';
import Slider from '../../common/Slider/index.tsx';
import s from '../../../redux/selectors';
import a from '../../../redux/actions';
import types from '../../../types';
import { wrap, withT } from '../../../lib/wrappers';

const SLIDER_PARAMS = {
  mpg: {
    tickValues: [10, 25, 40, 55, 70, 85, 100, 115],
    absMin: 10,
    absMax: 115,
    avg: 22,
  },
  lp100km: {
    tickValues: [2, 6, 10, 14, 18, 22, 26, 30],
    absMin: 2,
    absMax: 30,
    avg: 7,
  },
  kwhp100mi: {
    tickValues: [0, 50, 100, 150, 200, 250, 300, 350],
    absMin: 0,
    absMax: 350,
    avg: 30,
  },
  kwhp100km: {
    tickValues: [0, 40, 80, 120, 160, 200, 240, 280],
    absMin: 0,
    absMax: 280,
    avg: 20,
  },
};

const getSliderParams = (isMetric, isElectric) => {
  let paramsKey;
  if (isMetric) {
    paramsKey = isElectric ? 'kwhp100km' : 'lp100km';
  } else {
    paramsKey = isElectric ? 'kwhp100mi' : 'mpg';
  }
  return SLIDER_PARAMS[paramsKey];
};

const Travel = ({
  vehicle,
  isLastVehicle,
  t,
  updateNumericInput,
  updateVehicleFuelType,
  updateVehicleEfficiency,
  isMetric,
  removeVehicle,
}) => {
  const sliderParams = getSliderParams(isMetric, vehicle.isElectric);
  return (
    <div
      className="cc-component__question cc-component__question--vehicle"
    >
      <div className="input-group" style={{ position: 'relative', zIndex: '1' }}>
        <div
          id={`vehicle__${vehicle.index}__fuel_toggle`}
          className="input-group-btn"
        >
          <button
            type="button"
            className="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
          >
            {vehicle.fuelTypeDisplay}&nbsp;
            <span className="caret" />
          </button>
          <ul className="dropdown-menu">
            <li>
              <a
                role="button"
                href="#"
                onClick={
                  e => e.preventDefault() || updateVehicleFuelType(vehicle, { fuelType: 1 })
                }
              >
                {t('Gasoline')}
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={
                  e => e.preventDefault() || updateVehicleFuelType(vehicle, { fuelType: 2 })
                }
              >
                {t('Diesel')}
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={
                  e => e.preventDefault() || updateVehicleFuelType(vehicle, { isElectric: true })
                }
              >
                {t('Electric')}
              </a>
            </li>
          </ul>
        </div>
        <input
          aria-label={isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}
          className="form-control"
          id={`vehicle__annual_distance__${vehicle.index}`}
          value={vehicle.annualDistance}
          placeholder={vehicle.defaultDistance}
          onChange={e => updateNumericInput({
            [`transportation_miles${vehicle.index}`]: e.target.value,
          })}
        />
        <span className="input-group-addon">{isMetric ? t('km/yr', { ns: 'units' }) : t('mi/yr', { ns: 'units' })}</span>
        <span className="input-group-btn">
          <button
            type="button"
            className="btn btn-danger travel__vehicle__remove"
            onClick={() => removeVehicle(vehicle)}
          >X</button>
        </span>
      </div>
      {vehicle.isElectric &&
        <div className="vehicle__electricity-input-note">
          {t('Please enter {{unitSystem}} here (for vehicle manufacturing emissions) and then add your total household electricity consumption on the next (Housing) page', {
            unitSystem: isMetric ? t('kilometers', { ns: 'units' }) : t('miles', { ns: 'units' }),
          })}
        </div>
      }
      {!vehicle.isElectric &&
        <div className="label-container">
          <span className="label label-slider">
            {vehicle.efficiencyDisplay}
            <i> {vehicle.fuelEfficiencyUnit}</i>
          </span>
        </div>
      }
      {!vehicle.isElectric &&
        <Slider
          id={`vehicle_slider_${vehicle.index}`}
          min={sliderParams.absMin}
          max={sliderParams.absMax}
          step={0.01}
          ticks={sliderParams.tickValues.length}
          labels={sliderParams.tickValues.map(value => value.toString())}
          value={vehicle.efficiency}
          onChange={newValue => updateVehicleEfficiency(vehicle.index, newValue)}
        />
      }
      {!isLastVehicle && <hr />}
    </div>
  );
};

Travel.propTypes = {
  t: PropTypes.func.isRequired,
  vehicle: types.Vehicle.isRequired,
  isLastVehicle: PropTypes.bool.isRequired,
  isMetric: PropTypes.bool.isRequired,

  updateNumericInput: PropTypes.func.isRequired,
  updateVehicleFuelType: PropTypes.func.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  updateVehicleEfficiency: PropTypes.func.isRequired,
  removeVehicle: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'isMetric',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'removeVehicle',
    'updateNumericInput',
    'updateVehicleFuelType',
    'updateVehicleEfficiency',
  ]),
  dispatch,
);

export default wrap(
  withT('travel'),
  connect(mapStateToProps, mapDispatchToProps),
  Travel,
);
